import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  templateUrl: './create-dialog.component.html'
})
export class CreateDialogComponent {
  title: string;
  inputData: string;
  mode: number; // 0 - insert / 1 - edit
  type: number; // 0 - question / 1 - option
  constructor(private matDialogRef: MatDialogRef<CreateDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title;
    this.mode = data.mode;
    this.type = data.type;
    this.inputData = data.inputData ? data.inputData : '';
  }

  close(value?: string) {
    this.matDialogRef.close(value);
  }

  save() {
    if (this.inputData) {
      this.close(this.inputData);
    } else {
      const message = this.type === 0 ? 'Το πεδίο της ερώτησης είναι υποχρεωτικό' : 'Το πεδίο της απάντησης είναι υποχρεωτικό';
      this.toastMessagesService.toastMessages(message);
    }
  }

  cancel() {
    this.close();
  }
}
